module.exports = __webpack_public_path__ + "static/media/ic_general_close_radio_blue.e7db088d.svg";